import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export * from './layout.service';

export const APPLICATION_ID = new InjectionToken<BehaviorSubject<string>>(
  ''
);
